import React, { useState } from "react";
import Multiselect from "multiselect-react-dropdown";

export type MultiSelectDropdownProps = {
    options: { displayName: string; value: string }[];
    placeholder: string;
    hiddenInputName: string;
    initialValues: string[];
};

function MultiSelectDropdown(props: MultiSelectDropdownProps) {
    const [selectedValues, setSelectedValues] = useState<string[]>(props.initialValues);

    function selectedValuesChangeHandler(selectedOptions: { displayName: string; value: string }[]) {
        setSelectedValues([...selectedOptions.map((o) => o.value)]);
    }

    function keyPressHandler(event: any) {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    }

    const hiddenInputs = selectedValues.map((v) => (
        <input type="hidden" name={props.hiddenInputName} value={v} key={v} />
    ));

    const selectedOptions = props.options.filter((o) => selectedValues.includes(o.value));

    return (
        <>
            <Multiselect
                displayValue="displayName"
                placeholder={props.placeholder}
                options={props.options}
                selectedValues={selectedOptions}
                onSelect={selectedValuesChangeHandler}
                onRemove={selectedValuesChangeHandler}
                onKeyPressFn={keyPressHandler}
                hidePlaceholder={true}
            />
            {hiddenInputs}
        </>
    );
}

export default MultiSelectDropdown;
